import React from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../mendepartmentdetails/Sidebar';
import SubDeptImage from '../../../assets/image/department/modern-interface-payments-online-shopping-icon-customer-network-connection_512283-398.jpg';

function CitizenFocusedDigitalServices() {
  return (
    <section className="department-details-section">
      <div className="container">
        <div className="row">

          {/* Sidebar */}
          <div className="col-12 col-lg-4 col-xl-4">
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className="col-lg-8">
            <div className="department-details-imgbox">
              <img src={SubDeptImage} className="img-fluid" alt="Citizen-Focused Digital Services" />
            </div>

            <div className="department-details-content-box">
              <h4 className="department-details-title">Citizen-Focused Digital Services</h4>
              <p>
                This sub-department is dedicated to improving the accessibility and engagement of residents with public services through advanced digital platforms.<br />
                Initiatives include the development of user-friendly e-government services, mobile applications, and online portals for seamless interactions.<br /><br />
                Our goal is to ensure that residents can easily access the services they need, enhancing their overall experience and satisfaction.
              </p>
            </div>

            <div className="department-details-benefits-box">
              <h3>Key Services</h3>
              <ul className="list-unstyled list-style">
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Development of E-Government Platforms</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Mobile and Web Application Development</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Online Portals for Public Services</h5>
                </li>
              </ul>
            </div>

            <div className="department-details-policy-box">
              <h4>Our Commitment:</h4>
              <p>
                We are committed to bridging the gap between the government and its citizens by leveraging digital solutions, ensuring a more transparent and efficient interaction.
              </p>
            </div>
            <div>
              <Link to="/department/technology">
                <i className="fa-solid fa-circle-arrow-left" style={{ marginRight: '5px' }} />
                Go Back
              </Link>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default CitizenFocusedDigitalServices;
